import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "className", "type", "role", "dropdownClassName", "dropdownStyle", "disabled", "children", "visible", "onVisibleChange", "getPopupContainer", "buttonsRender", "buttonId", "splitButton", "kind", "compact", "data", "apperance", "onClick", "onSelect", "listHeight", "dropdownMatchWidth", "labelKey", "valueKey", "childrenKey", "disabledItemValues", "defaultValue", "value", "align", "dropdownItemArialabel", "prefixTemplate", "suffixTemplate", "itemTemplate", "customTriggerNode", "customTriggerClassName", "ariaLabel"];
// @ts-nocheck
import * as React from 'react';
import { useMemo, useCallback, useState, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { Button, ButtonGroup } from '../button';
import { DropdownMenu, OptionListContext } from '../select';
import useOptions from '../select/useOptions';
import { KEY_VALUES, useClickOutside, useControlled, mergeRefs } from '../utils';
import { useFocusItemValue, onMenuKeyDown } from './utils';
import { getEventSource } from '../utils/shadowDomUtils';
import { flattenItemsFun } from '../select/utils';
var DropdownButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;
  var id = props.id,
    className = props.className,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    _props$role = props.role,
    role = _props$role === void 0 ? 'button' : _props$role,
    dropdownClassName = props.dropdownClassName,
    dropdownStyle = props.dropdownStyle,
    disabled = props.disabled,
    children = props.children,
    _props$visible = props.visible,
    visibleProp = _props$visible === void 0 ? false : _props$visible,
    onVisibleChange = props.onVisibleChange,
    getPopupContainer = props.getPopupContainer,
    buttonsRender = props.buttonsRender,
    buttonId = props.buttonId,
    splitButton = props.splitButton,
    _props$kind = props.kind,
    kind = _props$kind === void 0 ? 'primary' : _props$kind,
    _props$compact = props.compact,
    compact = _props$compact === void 0 ? false : _props$compact,
    data = props.data,
    _props$apperance = props.apperance,
    apperance = _props$apperance === void 0 ? 'button' : _props$apperance,
    onClick = props.onClick,
    onSelect = props.onSelect,
    listHeight = props.listHeight,
    _props$dropdownMatchW = props.dropdownMatchWidth,
    dropdownMatchWidth = _props$dropdownMatchW === void 0 ? false : _props$dropdownMatchW,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    _props$childrenKey = props.childrenKey,
    childrenKey = _props$childrenKey === void 0 ? 'children' : _props$childrenKey,
    disabledItemValues = props.disabledItemValues,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    value = props.value,
    _props$align = props.align,
    align = _props$align === void 0 ? 'right' : _props$align,
    _props$dropdownItemAr = props.dropdownItemArialabel,
    dropdownItemArialabel = _props$dropdownItemAr === void 0 ? false : _props$dropdownItemAr,
    prefixTemplate = props.prefixTemplate,
    suffixTemplate = props.suffixTemplate,
    itemTemplate = props.itemTemplate,
    _props$customTriggerN = props.customTriggerNode,
    customTriggerNode = _props$customTriggerN === void 0 ? false : _props$customTriggerN,
    customTriggerClassName = props.customTriggerClassName,
    ariaLabel = props.ariaLabel,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var leftButton, rightButton;
  var popupRef = React.useRef(null);
  var targetRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var _useState = useState(visibleProp),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useControlled = useControlled(value, defaultValue),
    internalValue = _useControlled[0],
    setInternalValue = _useControlled[1];
  var _useOptions = useOptions(data, children, childrenKey, valueKey, labelKey),
    flattenItems = _useOptions.flattenItems,
    parsedItems = _useOptions.mergedItems;
  var displayItems = React.useMemo(function () {
    return flattenItemsFun(parsedItems, {
      childrenKey: childrenKey,
      valueKey: valueKey,
      labelKey: labelKey
    });
  }, [parsedItems]);
  // const [alignDropdown, setAlignDropdown] = useState({
  //     'ap-button-dropdown-left': false,
  //     'ap-button-dropdown-right': false,
  //     'ap-button-dropdown-top': false,
  //     'ap-button-dropdown-bottom': false
  // });
  var dropdownProps = {
    id: 'groupdropdown',
    role: 'menu',
    disabled: disabled,
    visible: visible,
    // getPopupContainer: getPopupContainer || popupRef?.current,
    className: classNames('ap-button-dropdown', dropdownClassName, {
      show: customTriggerNode && visible,
      'align-left': align === 'left',
      'align-right': align === 'right'
    }),
    style: dropdownStyle,
    // listHeight: listHeight || 256,
    // onVisibleChange,
    dropdownItemArialabel: dropdownItemArialabel,
    prefixTemplate: prefixTemplate,
    suffixTemplate: suffixTemplate,
    itemTemplate: itemTemplate,
    labelKey: labelKey,
    valueKey: valueKey
  };
  var buttonAriaAttributes = useMemo(function () {
    return {
      'aria-haspopup': true,
      'aria-expanded': visible,
      'aria-controls': (buttonId ? buttonId : splitButton ? 'group' : 'menu') + 'dropdown',
      className: splitButton ? 'group-right' : customTriggerNode ? customTriggerClassName + ' custom' : '',
      compact: compact,
      disabled: disabled,
      ref: targetRef
    };
  }, [visible, buttonId, splitButton, compact, disabled, customTriggerClassName]);
  var buttonProps = useMemo(function () {
    return _extends({
      id: buttonId
    }, buttonAriaAttributes);
  }, [buttonId, buttonAriaAttributes, visible]);
  useLayoutEffect(function () {
    if (visible && popupRef.current) {
      if (typeof dropdownMatchWidth === 'number') {
        popupRef.current.style.width = dropdownMatchWidth + "px";
      } else if (dropdownMatchWidth) {
        var _targetRef$current;
        var width = (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 ? void 0 : _targetRef$current.offsetWidth;
        popupRef.current.style.width = width + "px";
      }
    }
  }, [popupRef.current, visible, dropdownMatchWidth]);
  var hideOnClickOutside = function hideOnClickOutside() {
    if (visible) {
      setVisible(false);
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
    }
  };
  var _useFocusItemValue = useFocusItemValue(internalValue, visible, {
      items: flattenItems,
      labelKey: labelKey,
      valueKey: valueKey,
      disabledItemValues: disabledItemValues
    }),
    focusItemValue = _useFocusItemValue.focusItemValue,
    setFocusItemValue = _useFocusItemValue.setFocusItemValue,
    handleKeyDown = _useFocusItemValue.onKeyDown,
    findFocusItemIndex = _useFocusItemValue.findFocusItemIndex;
  var handleKeyDownEvent = function handleKeyDownEvent(event) {
    event.stopPropagation();
    var key = event.key;
    var isDown = key === KEY_VALUES.DOWN;
    var isUp = key === KEY_VALUES.UP;
    var isEnter = key === KEY_VALUES.ENTER;
    var isSpace = key === KEY_VALUES.SPACE;
    if (!visible) {
      if (isEnter || isDown || isSpace || isUp) {
        event.preventDefault();
        setVisible(true);
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(true);
        if ((isEnter || isSpace) && !splitButton) {
          onClick === null || onClick === void 0 ? void 0 : onClick(event);
        }
        // void -> visible
        // UP -> reverse
        // DOWN
        findFocusItemIndex(function (item, index) {
          if (index === -1 && item.length > 0) {
            setFocusItemValue({
              keyboard: true,
              value: item[0][valueKey]
            });
          } else if (index > -1) {
            setFocusItemValue({
              keyboard: true,
              value: item[index][valueKey]
            });
          }
        }, '', isUp);
      }
      return;
    }
    onMenuKeyDown(event, {
      enter: handleSelect,
      esc: handleClose
    });
    handleKeyDown(event);
    if (isEnter || isSpace) {
      if (visible && !focusItemValue.value) {
        setVisible(false);
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
      }
    }
  };
  var handleClose = function handleClose(event) {
    if (visible) {
      event.stopPropagation();
    }
    setVisible(false);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
  };
  var onInternalSelect = useCallback(function (v, item, event) {
    setInternalValue(v);
    setFocusItemValue({
      keyboard: false,
      value: v
    });
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(v, item, event);
    if (event.defaultPrevented) {
      return;
    }
    setVisible(false);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
  }, [onSelect, displayItems]);
  var handleToggle = function handleToggle(event) {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    var newVisible = !visible;
    setVisible(newVisible);
    setFocusItemValue(_extends({}, focusItemValue, {
      keyboard: false
    }));
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(newVisible);
    if (splitButton) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  var handleSelect = useCallback(function (event) {
    if (!focusItemValue.value) {
      return;
    }
    setInternalValue(focusItemValue.value);
    var index = flattenItems.findIndex(function (item) {
      return item[valueKey] === focusItemValue.value;
    });
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(focusItemValue.value, flattenItems[index], event);
    if (event.defaultPrevented) {
      return;
    }
    setVisible(false);
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
  }, [visible, onSelect, onVisibleChange, focusItemValue]);
  useClickOutside({
    enabled: visible,
    isOutside: function isOutside(event) {
      var _popupRef$current, _targetRef$current2;
      var eventSource = getEventSource(event);
      return !((_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(eventSource)) && !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(eventSource));
    },
    handle: hideOnClickOutside
  });
  var handleLeftClick = function handleLeftClick(e) {
    if (disabled) {
      return;
    }
    if (e.type === 'keydown') {
      handleLeftKeyDownEvent(e);
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  var handleLeftKeyDownEvent = function handleLeftKeyDownEvent(event) {
    event.stopPropagation();
    var key = event.key;
    var isEnter = key === KEY_VALUES.ENTER;
    var isSpace = key === KEY_VALUES.SPACE;
    if (isEnter || isSpace) {
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
      if (visible) {
        setVisible(false);
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(false);
      }
    }
  };
  rightButton = /*#__PURE__*/React.createElement(Button, _extends({
    kind: kind,
    onClick: handleToggle,
    onKeyDown: handleKeyDownEvent,
    ariaLabel: ariaLabel
  }, buttonProps), !splitButton && children, /*#__PURE__*/React.createElement("span", {
    className: classNames('Appkit4-icon icon-down-chevron-outline', {
      rotate: visible,
      disabled: disabled
    }),
    "aria-hidden": true
  }));
  if (splitButton) {
    leftButton = /*#__PURE__*/React.createElement(Button, {
      kind: kind,
      disabled: disabled,
      compact: compact,
      onClick: handleLeftClick,
      className: "group-left",
      role: role,
      type: type
    }, children);
  }
  var _ref = buttonsRender([leftButton, rightButton]),
    leftButtonToRender = _ref[0],
    rightButtonToRender = _ref[1];
  var wrapperClassed = classNames(className, {
    'ap-field-dropdown-wrapper': apperance === 'field',
    'ap-buttons-wrapper': apperance === 'button' || customTriggerNode
  });
  var selectContext = React.useMemo(function () {
    return {
      flattenItems: displayItems,
      onSelect: onInternalSelect,
      focusItemValue: focusItemValue,
      selectedValues: internalValue,
      disabledItemValues: disabledItemValues
    };
  }, [displayItems, onInternalSelect, focusItemValue, internalValue, disabledItemValues]);
  var customProps = _extends({}, buttonProps);
  if (customTriggerNode) delete customProps['compact'];
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: mergeRefs(ref, containerRef),
    className: wrapperClassed,
    id: id
  }, restProps), customTriggerNode ? /*#__PURE__*/React.createElement("div", _extends({
    role: role,
    type: type,
    tabIndex: 0,
    "aria-label": ariaLabel,
    onClick: disabled ? undefined : handleToggle,
    onKeyDown: disabled ? undefined : handleKeyDownEvent
  }, customProps), children) : apperance === 'button' ? /*#__PURE__*/React.createElement(ButtonGroup, {
    className: classNames(className, (_classNames = {}, _classNames["ap-group-buttons"] = splitButton, _classNames["ap-menu-buttons"] = !splitButton, _classNames)),
    gap: 2
  }, leftButtonToRender, rightButtonToRender) : /*#__PURE__*/React.cloneElement(children, {
    onKeyDown: handleKeyDownEvent,
    onClick: handleToggle,
    ref: targetRef
  }), /*#__PURE__*/React.createElement(OptionListContext.Provider, {
    value: selectContext
  }, !customTriggerNode ? (apperance === 'button' && visible || apperance === 'field') && /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    ref: popupRef
  }, dropdownProps)) : /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    ref: popupRef
  }, dropdownProps))));
});
DropdownButton.defaultProps = {
  buttonsRender: function buttonsRender(buttons) {
    return buttons;
  }
};
DropdownButton.displayName = 'DropdownButton';
export default DropdownButton;